import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

const verbFor = (type, claimedAt) => {
  if (claimedAt) return 'claimed';
  return type === 'loyalty-prize' ? 'won' : 'earned';
};

const LoyaltyActivity = ({
  items, onSelectFan, hasMore, loading, onLoadMore,
}) => (
  <div className="panel">
    <div className="panel-h">
      <span className="ph-t">Recent activity</span>
      <span className="spacer" />
      <span className="ph-s">most recent</span>
    </div>
    {items.map((item, index) => {
      const {
        email, slugName, type, createdAt, claimedAt,
      } = item;
      const isAchievement = type === 'loyalty-achievement';
      const verb = verbFor(type, claimedAt);
      let tagClass = 'open';
      if (isAchievement) tagClass = 'ach';
      else if (claimedAt) tagClass = 'prize';
      const tagText = isAchievement || claimedAt ? slugName : `${slugName} · open`;
      const parsed = createdAt ? moment(createdAt) : null;
      const when = parsed && parsed.isValid() ? parsed.fromNow() : '—';

      return (
        // eslint-disable-next-line react/no-array-index-key
        <div key={`${email}-${slugName}-${createdAt}-${index}`} className="act" onClick={() => onSelectFan(email)}>
          <span className={`dot${isAchievement ? ' a' : ''}`} />
          <span className="txt">
            <b>{email}</b>
            {' '}
            <span className="s">{verb}</span>
            {' '}
            <span className={`tag ${tagClass}`}>{tagText}</span>
          </span>
          <span className="when">{when}</span>
        </div>
      );
    })}
    <div className="loadmore">
      {hasMore ? (
        <button type="button" className="pg" disabled={loading} onClick={onLoadMore}>
          {loading ? 'Loading…' : 'Load more'}
        </button>
      ) : null}
    </div>
  </div>
);

LoyaltyActivity.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    email: PropTypes.string,
    slugName: PropTypes.string,
    type: PropTypes.string,
    points: PropTypes.number,
    createdAt: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    claimedAt: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  })).isRequired,
  onSelectFan: PropTypes.func.isRequired,
  hasMore: PropTypes.bool,
  loading: PropTypes.bool,
  onLoadMore: PropTypes.func.isRequired,
};

LoyaltyActivity.defaultProps = {
  hasMore: false,
  loading: false,
};

export default LoyaltyActivity;
